/**
 * @description Typography constants for the shared workspace. In general, these classes
 * will be used with the `TextV2` component. You can use the typography enum values directly
 * in the `type` prop of the `TextV2` component.
 */
import { tv } from 'tailwind-variants'

export enum TYPOGRAPHY {
  header0 = 'header0',
  header1 = 'header1',
  header2 = 'header2',
  header3 = 'header3',
  header4 = 'header4',
  header5 = 'header5',
  header6 = 'header6',
  paragraph0 = 'paragraph0',
  paragraph1 = 'paragraph1',
  paragraph2 = 'paragraph2',
  paragraph3 = 'paragraph3',
  label1 = 'label1',
  label2 = 'label2',
  label3 = 'label3',
  label4 = 'label4',
  uppercaseLabel1 = 'uppercaseLabel1',
  uppercaseLabel2 = 'uppercaseLabel2',
  uppercaseLabel2noResponsive = 'uppercaseLabel2noResponsive',
  uppercaseLabel3 = 'uppercaseLabel3',
}

export const header = tv({
  base: 'text-primary-black font-[Overpass] font-semibold not-italic',
  variants: {
    type: {
      header0: 'text-5xl leading-[1.53] sm:text-[35px] md:text-4xl',
      header1: 'text-3xl leading-[1.53] sm:text-[28px]',
      header2: 'text-2xl leading-[1.54] sm:text-[22px]',
      header3: 'text-base leading-[1.56] sm:text-sm',
      header4: 'text-sm leading-normal', // replacement for h4 design wanted to use interim
      header5: 'text-xs leading-normal',
      header6: 'text-xl leading-normal', // 20 px is not a mistake, it's a replacement for h1 design wanted to use interim
    },
  },
})

export const paragraph = tv({
  base: 'text-primary-black font-[Overpass] text-base leading-[1.56] font-light not-italic',
  variants: {
    type: {
      paragraph0: 'text-lg leading-[1.56] sm:text-base',
      paragraph1: 'text-base leading-[1.56] sm:text-sm',
      paragraph2: 'text-sm leading-normal',
      paragraph3: 'text-xs leading-normal',
    },
  },
})

export const label = tv({
  base: 'text-primary-black font-[Overpass]',
  variants: {
    type: {
      label1: 'text-xl leading-[1.55]',
      label2: 'text-base leading-[1.56] sm:text-sm',
      label3: 'text-sm leading-normal',
      label4: 'text-xs leading-normal',
    },
  },
})

export const uppercaseLabel = tv({
  base: 'text-primary-black font-[Overpass] font-semibold tracking-[0.15em] uppercase not-italic',
  variants: {
    type: {
      uppercaseLabel1: 'text-base leading-[1.4] sm:text-[13px]',
      uppercaseLabel2: 'text-[13px] leading-[1.53] sm:text-[11px]',
      uppercaseLabel2noResponsive: 'text-xs leading-[1.53]',
      uppercaseLabel3: 'text-xs leading-normal',
    },
  },
})
